import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";

export const useFetchText = (filename) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    const fetchText = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.PUBLIC_URL}/app_text/${filename}`
        );
        if (response.status !== 200) {
          throw new Error("Failed to fetch the text");
        }
        setData(response?.data);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };
    fetchText();
  }, [filename]);

  return { data, loading, error };
};